import { render, staticRenderFns } from "./BaseNotificationBar.vue?vue&type=template&id=a848008c&scoped=true&"
import script from "./BaseNotificationBar.vue?vue&type=script&lang=js&"
export * from "./BaseNotificationBar.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotificationBar.vue?vue&type=style&index=0&id=a848008c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a848008c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
